import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Campus } from 'src/app/core/models/api/campus.model';
import { CampusResourceService } from 'src/app/core/services/api/campus-resource.service';

@Component({
    selector: 'app-contact-data',
    templateUrl: './contact-data.component.html',
    styleUrls: ['./contact-data.component.scss']
})
export class ContactDataComponent implements OnInit {

    @Input() campus: Campus;

    phoneNormal       : string;
    phoneCampus       : string;
    scheduleNormal    : string;
    scheduleCampus    : string;
    mail              : string;
    office            : string;
    mapLocation       : SafeResourceUrl;

    constructor(private sanitizer: DomSanitizer, private campusResourceService: CampusResourceService) { }

    ngOnInit() {

        this.getCampusResources();

    }

    getCampusResources() {

        this.phoneNormal    = this.campusResourceService.findResource(this.campus.resources, 'contact-phone-normal');
        this.phoneCampus    = this.campusResourceService.findResource(this.campus.resources, 'contact-phone-campus');
        this.scheduleNormal = this.campusResourceService.findResource(this.campus.resources, 'contact-schedule-normal');
        this.scheduleCampus = this.campusResourceService.findResource(this.campus.resources, 'contact-schedule-campus');
        this.mail           = this.campusResourceService.findResource(this.campus.resources, 'contact-mail');
        this.office         = this.campusResourceService.findResource(this.campus.resources, 'contact-office');
        
        var mapLocationResource = this.campusResourceService.findResource(this.campus.resources, 'contact-map-location');
        this.mapLocation        = mapLocationResource ? this.getSafeResourceURL(mapLocationResource) : null;

    }

    getSafeResourceURL(url: string) {

        return this.sanitizer.bypassSecurityTrustResourceUrl(url);

    }

}
